const getLangPrefix = ({ lang }) => (lang === 'en' ? '' : `/${lang}`);

export default getLangPrefix;
